import { useEffect } from 'react';

/** The product's name: a name rather than a word, so it reads the same in every language, as on the logo. */
const PRODUCT = 'entegrepazar';

/**
 * Names the page in the browser tab, its history and a bookmark (docs/15 §7):
 * the parts from the most specific out, then the product — "Depolar · Stok —
 * entegrepazar". A part not known yet, such as a record still loading, is left
 * out rather than written as a blank.
 *
 * Every page calls it, and lint holds that. Leaving a page puts the product's
 * name back alone, so a screen that names nothing — the moment before the
 * session is known — never keeps the title of the page before it.
 */
export function usePageTitle(...parts: Array<string | null | undefined>): void {
    const title = parts.filter((part): part is string => Boolean(part)).join(' · ');

    useEffect(() => {
        document.title = title ? `${title} — ${PRODUCT}` : PRODUCT;
        return () => {
            document.title = PRODUCT;
        };
    }, [title]);
}
